import React from 'react';
import ModuleRenderer from '../renderers/ModuleRenderer';
import { GRID_CELL_SIZE_M, defaultObjectSizes, OBJECT_TYPES } from '../configuratorConstants';
import { createInitialWallSegments } from '../configuratorUtils';

const PREVIEW_CONTAINER_SIZE = 120;
const PREVIEW_PADDING = 8;

// Эта функция временно дублирует логику добавления элементов для превью.
// В идеале, ее нужно вынести в общий сервис.
const getAutoPlacedElementsForSubtype = (subtype) => {
    if (subtype === 'shower') {
        return [
            { "type": OBJECT_TYPES.DOOR, "segmentKey": "0,0_h", "properties": { "positionOnSegment": 0.5, "openingDirection": "inward", "hingeSide": "right" } },
            { "type": OBJECT_TYPES.SWITCH_DOUBLE, "segmentKey": "0,0_v", "properties": { "positionOnSegment": 0.5 } },
            { "type": OBJECT_TYPES.OUTLET_DOUBLE, "segmentKey": "0,1_v", "properties": { "positionOnSegment": 0.4 } },
            { "type": OBJECT_TYPES.SWITCH_DOUBLE, "segmentKey": "0,2_v", "properties": { "positionOnSegment": 0.5 } },
            { "type": OBJECT_TYPES.OUTLET_DOUBLE, "segmentKey": "0,5_h", "properties": { "positionOnSegment": 0.3 } },
            { "type": OBJECT_TYPES.OUTLET_DOUBLE, "segmentKey": "1,5_h", "properties": { "positionOnSegment": 0.7 } }
        ];
    }
     return [];
};

const ModulePreviewRenderer = ({ template }) => {
    if (!template || !template.config) return null;

    let config;
    try {
        config = typeof template.config === 'string' ? JSON.parse(template.config) : template.config;
    } catch (e) {
        console.error("Failed to parse template config in preview:", template.name, e);
        return null;
    }

    const { cellsWide, cellsLong } = config;
    const moduleWidthM = cellsWide * GRID_CELL_SIZE_M;
    const moduleHeightM = cellsLong * GRID_CELL_SIZE_M;

    const availableSize = PREVIEW_CONTAINER_SIZE - PREVIEW_PADDING * 2;
    const scale = Math.min(availableSize / moduleWidthM, availableSize / moduleHeightM);

    const svgWidth = moduleWidthM * scale + PREVIEW_PADDING * 2;
    const svgHeight = moduleHeightM * scale + PREVIEW_PADDING * 2;

    const moduleForRenderer = {
        id: `preview-${template.id}`,
        x: 0,
        y: 0,
        width: moduleWidthM,
        height: moduleHeightM,
        ...config,
        templateId: config.id, 
        wallSegments: createInitialWallSegments(config),
    };

    const predefinedElements = config.predefinedElements || [];
    const autoPlacedElements = getAutoPlacedElementsForSubtype(config.subtype);
    const allElements = [...predefinedElements, ...autoPlacedElements];
    
    const uniqueElementKeys = new Set();
    const uniqueElements = allElements.filter(el => {
        const key = `${el.type}-${el.segmentKey}-${el.properties?.positionOnSegment}`;
        if (uniqueElementKeys.has(key)) {
            return false;
        } else {
            uniqueElementKeys.add(key);
            return true;
        }
    });

    uniqueElements.forEach(el => {
        if (moduleForRenderer.wallSegments[el.segmentKey]) {
            if (!moduleForRenderer.wallSegments[el.segmentKey].elements) {
                moduleForRenderer.wallSegments[el.segmentKey].elements = [];
            }
            moduleForRenderer.wallSegments[el.segmentKey].elements.push({
                id: `preview-el-${Math.random()}`,
                type: el.type,
                ...defaultObjectSizes[el.type],
                ...el.properties,
            });
        }
    });

    return (
        <svg
            viewBox={`-${PREVIEW_PADDING} -${PREVIEW_PADDING} ${svgWidth} ${svgHeight}`}
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid meet"
        >
            <ModuleRenderer
                module={moduleForRenderer}
                scale={scale}
                isGhost={true}
                selectedObjectId={null}
                setSelectedObjectId={() => {}}
                onContextMenu={() => {}}
                onSelectElement={() => {}}
                onWallSegmentClick={() => {}}
                onToggleWallSegment={() => {}}
            />
        </svg>
    );
};

export default React.memo(ModulePreviewRenderer);